export default "__VITE_ASSET__e726717e__"